
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.25 10.5H7.25C6.97386 10.5 6.75 10.7239 6.75 11V19C6.75 19.2761 6.97386 19.5 7.25 19.5H16.75C17.0261 19.5 17.25 19.2761 17.25 19V11C17.25 10.7239 17.0261 10.5 16.75 10.5H15.75V8.25C15.75 6.17893 14.0711 4.5 12 4.5C9.92893 4.5 8.25 6.17893 8.25 8.25V10.5ZM9.25 10.5H14.75V8.25C14.75 6.73122 13.5188 5.5 12 5.5C10.4812 5.5 9.25 6.73122 9.25 8.25V10.5Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiLockFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
